import TooltipEllipsis from '@deltek/specification-client/core/Feedbacks/TooltipEllipsis'
import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import clsx from 'clsx'
import React from 'react'
import { ThumbnailImageStyles } from './GalleryItem'

const uploadResultItemStyles = makeStyles((theme: Theme) => ({
    uploadResultItemContainer: {
        marginBottom: theme.spacing(1),
        fontSize: pxToRem(14),
    },
    uploadImageHeightWidth: {
        width: 190,
        height: 95,
    },
    uploadImage: {
        objectFit: 'cover',
    },
    successfulContainer: {
        display: 'flex',
        alignItems: 'center',
        '& .successUnsuccessfulIcon': {
            marginRight: theme.spacing(0.5),
        },
        '& .successful': {
            color: '#219653',
        },
        '& .unsuccessful': {
            color: '#E97E7E',
        },
    },
    noImageThumbText: {
        color: '#fff',
        fontWeight: 500,
    },
    lightGrayBackground: {
        backgroundColor: '#c9c9c9',
    },
    noImgThumbnail: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}))

export interface UploadResultItemProps {
    filename: string
    imageUrl: string
    success: boolean
}

const UploadResultItem = ({
    filename,
    success,
    imageUrl,
}: UploadResultItemProps) => {
    const classes = uploadResultItemStyles()
    const thumbnailImageClasses = ThumbnailImageStyles()
    return (
        <GridContainer
            spacing={3}
            className={clsx(
                classes.uploadResultItemContainer,
                'uploadResultItemContainer'
            )}
            alignItems="center"
        >
            <GridItem>
                {success ? (
                    <img
                        src={imageUrl}
                        alt={filename}
                        className={clsx(
                            thumbnailImageClasses.thumbnailImage,
                            thumbnailImageClasses.thumbnailImageHeightWidth
                        )}
                    />
                ) : (
                    <div
                        className={clsx(
                            thumbnailImageClasses.thumbnailImageHeightWidth,
                            classes.noImgThumbnail,
                            classes.lightGrayBackground
                        )}
                    >
                        <Typography
                            className={classes.noImageThumbText}
                            variant="h6"
                            component="span"
                        >
                            No Image
                        </Typography>
                    </div>
                )}
            </GridItem>
            <GridItem sm={5}>
                <TooltipEllipsis text={filename} />
            </GridItem>
            <GridItem sm={3}>
                <div className={classes.successfulContainer}>
                    <span
                        className={clsx(
                            success ? 'successful' : 'unsuccessful',
                            'successUnsuccessfulIcon'
                        )}
                    >
                        {success ? (
                            <CheckCircleOutlineIcon />
                        ) : (
                            <HighlightOffIcon />
                        )}
                    </span>
                    <span>Successful</span>
                </div>
            </GridItem>
        </GridContainer>
    )
}

export default UploadResultItem
